import { EventStream } from '@cgs/wge';
import { SpinResponse } from '@cgs/data-access';
import { SlotSessionProperties } from '@cgs/machines';
import { BetDisplayData, FreeSpinsModeData, HudAvailabilityData } from './cgs-hud-bridge-events';

export const HUD_BRIDGE_TOKEN = Symbol('IHudBridge');

export interface IHudBridge {
  // Game → HUD events
  readonly onStateEntered: EventStream<string>;
  readonly onStateExited: EventStream<string>;
  readonly onSessionPropertyChanged: EventStream<SlotSessionProperties>;
  readonly onPopupShown: EventStream<string>;
  readonly onPopupHidden: EventStream<string>;
  readonly onHudDisableRequest: EventStream<void>;

  // Computed data events (game logic → HUD display)
  readonly onBetDisplayChanged: EventStream<BetDisplayData>;
  readonly onFreeSpinsModeChanged: EventStream<FreeSpinsModeData>;
  readonly onHudAvailabilityChanged: EventStream<HudAvailabilityData>;

  // HUD → Game commands
  doSpin(): void;
  doStop(): void;
  changeBetIndex(delta: number): void;

  // Read-only data access
  readonly isAutoSpins: boolean;
  readonly currentResponse: SpinResponse | null;
  readonly isFastSpinsEnabled: boolean;
  isActive(stateId: string): boolean;
}
